(function () {
  var namespace = (window.GratiaStampedLazy = window.GratiaStampedLazy || {});
  var config = namespace.config || {};
  var scriptSrc = config.scriptSrc || "https://cdn1.stamped.io/files/widget.min.js";
  var scriptSelector = 'script[src*="cdn1.stamped.io/files/widget.min.js"]';
  var hasInitialized = false;
  var loadPromise = null;
  var viewportIntentBound = false;
  var viewportObserver = null;

  function isStampedResident() {
    return Boolean(window.StampedFn && typeof window.StampedFn.init === "function");
  }

  function addResourceHint(rel, href, crossOrigin) {
    if (document.querySelector('link[rel="' + rel + '"][href="' + href + '"]')) return;

    var link = document.createElement("link");
    link.rel = rel;
    link.href = href;
    if (crossOrigin) link.crossOrigin = "anonymous";
    document.head.appendChild(link);
  }

  function initStamped() {
    if (!isStampedResident()) return;

    disconnectViewportObserver();

    if (!hasInitialized) {
      window.StampedFn.init({
        apiKey: config.apiKey,
        storeUrl: config.storeUrl,
      });
      hasInitialized = true;
      document.dispatchEvent(new CustomEvent("gratia:stamped:loaded"));
      return;
    }

    if (typeof window.StampedFn.reloadUGC === "function") {
      window.StampedFn.reloadUGC();
    }
  }

  function loadStamped() {
    if (isStampedResident()) {
      initStamped();
      return Promise.resolve(window.StampedFn);
    }

    if (loadPromise) return loadPromise;

    addResourceHint("preconnect", "https://cdn1.stamped.io", true);
    addResourceHint("preconnect", "https://stamped.io", true);

    loadPromise = new Promise(function (resolve, reject) {
      var existingScript = document.querySelector(scriptSelector);
      var script = existingScript || document.createElement("script");

      script.addEventListener("load", function () {
        script.setAttribute("data-gratia-stamped-loaded", "true");
        initStamped();
        resolve(window.StampedFn);
      });

      script.addEventListener("error", function () {
        loadPromise = null;
        reject(new Error("Stamped widget failed to load"));
      });

      if (existingScript) {
        if (existingScript.getAttribute("data-gratia-stamped-loaded") === "true") {
          initStamped();
          resolve(window.StampedFn);
        }
        return;
      }

      script.async = true;
      script.src = scriptSrc;
      script.setAttribute("data-gratia-stamped-lazy", "true");
      document.head.appendChild(script);

      if (script.readyState === "complete") {
        initStamped();
        resolve(window.StampedFn);
      }
    });

    return loadPromise;
  }

  function disconnectViewportObserver() {
    if (!viewportObserver) return;
    viewportObserver.disconnect();
    viewportObserver = null;
  }

  function getReviewViewportTargets() {
    return document.querySelectorAll(
      [
        "[data-stamped-lazy-root]",
        '.m-tab-header[data-block-type="reviews"]',
      ].join(",")
    );
  }

  function bindIntentLoad(scope) {
    (scope || document)
      .querySelectorAll(
        [
          "[data-stamped-lazy-root]",
          '.m-tab-header[data-block-type="reviews"]',
          'a[href*="#reviews"]',
          'a[href*="#stamped"]',
        ].join(",")
      )
      .forEach(function (trigger) {
        if (trigger.getAttribute("data-gratia-stamped-intent-bound") === "true") return;
        trigger.setAttribute("data-gratia-stamped-intent-bound", "true");
        trigger.addEventListener("click", loadStamped, { once: true });
        trigger.addEventListener("focusin", loadStamped, { once: true });
      });

    if (window.location.hash && window.location.hash.match(/reviews|stamped/i)) {
      loadStamped().catch(function () {});
    }
  }

  function bindViewportLoad() {
    if (viewportObserver || loadPromise || hasInitialized) return;
    if (!("IntersectionObserver" in window)) return;

    var targets = getReviewViewportTargets();
    if (!targets.length) return;

    viewportObserver = new IntersectionObserver(
      function (entries) {
        var isNearReviews = entries.some(function (entry) {
          return entry.isIntersecting;
        });

        if (!isNearReviews) return;

        disconnectViewportObserver();
        loadStamped().catch(function () {});
      },
      {
        rootMargin: "0px 0px 150px 0px",
        threshold: 0.01,
      }
    );

    targets.forEach(function (target) {
      viewportObserver.observe(target);
    });
  }

  function bindViewportIntentLoad() {
    if (viewportIntentBound || viewportObserver || loadPromise || hasInitialized) return;
    viewportIntentBound = true;

    function removeViewportIntentListeners() {
      window.removeEventListener("wheel", enableViewportLoad);
      window.removeEventListener("touchmove", enableViewportLoad);
      window.removeEventListener("keydown", handleViewportKeydown);
    }

    function enableViewportLoad() {
      removeViewportIntentListeners();
      window.requestAnimationFrame(function () {
        bindViewportLoad();
      });
    }

    function handleViewportKeydown(event) {
      if (!["ArrowDown", "PageDown", "End", " "].includes(event.key)) return;
      enableViewportLoad();
    }

    window.addEventListener("wheel", enableViewportLoad, { once: true, passive: true });
    window.addEventListener("touchmove", enableViewportLoad, { once: true, passive: true });
    window.addEventListener("keydown", handleViewportKeydown);
  }

  function observeTargets(event) {
    if (window.Shopify && window.Shopify.designMode) {
      loadStamped().catch(function () {});
      return;
    }

    if (hasInitialized) {
      initStamped();
      return;
    }

    if (isStampedResident()) {
      initStamped();
      return;
    }

    bindIntentLoad(event && event.target ? event.target : document);
    bindViewportIntentLoad();
  }

  function init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", observeTargets, { once: true });
    } else {
      observeTargets();
    }
  }

  namespace.load = loadStamped;
  namespace.init = observeTargets;

  init();
  document.addEventListener("shopify:section:load", observeTargets);
  document.addEventListener("gratia:product:swapped", function (event) {
    disconnectViewportObserver();
    observeTargets({
      target: event.detail && event.detail.productInfo ? event.detail.productInfo : document,
    });
  });
})();
